import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardsPage from './pages/DashboardsPage';
import { ReportViewContainer } from './modules/reports';
import AppLayout from './components/AppLayout';
import { SessionProvider } from './auth/SessionContext';

function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboards" element={<DashboardsPage />} />
            <Route path="/reports/:reportId" element={<ReportViewContainer />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </SessionProvider>
    </BrowserRouter>
  );
}

export default App;
